import { render, staticRenderFns } from "./DDSAverageTimeChart.vue?vue&type=template&id=1a62e915&scoped=true"
import script from "./DDSAverageTimeChart.vue?vue&type=script&lang=js"
export * from "./DDSAverageTimeChart.vue?vue&type=script&lang=js"
import style0 from "./DDSAverageTimeChart.vue?vue&type=style&index=0&id=1a62e915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a62e915",
  null
  
)

export default component.exports